import { IconBellRinging } from "@tabler/icons-react";
import NotifPrefRow from "./NotifPrefRow";
import { EMAIL_NOTIF_PREFS } from "./data";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function EmailNotificationsCard() {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconBellRinging size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Email Notifications</div>
            <div className={styles.cardSubtitle}>
              Choose what updates you receive by email
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.notifPrefList}>
          {EMAIL_NOTIF_PREFS.map((pref) => (
            <NotifPrefRow key={pref.id} pref={pref} />
          ))}
        </div>
      </div>
    </div>
  );
}
